export default "<app-calendario-view-mensal></app-calendario-view-mensal>";